import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Home = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out', 
      once: false, 
    });
  }, []);

  return (
    <div className="flex justify-center items-center text-white text-start h-screen -z-50" data-aos="fade-down-left">
      <div className="flex flex-col justify-start items-start gap-2 mx-10">
        <div className="text-4xl font-extrabold tracking-wider">
          <p className="bg-clip-text text-transparent bg-gradient-to-r from-white to-[#00E6F6]">HELLO</p>
          <p className="bg-clip-text text-transparent bg-gradient-to-r from-white to-[#00E6F6]">I'M KARTHI SRINIVASAN</p>
        </div>
        <p className="text-lg">
          Any fool can write code that a computer can understand. Good
          programmers write code that humans can understand.
        </p>
        <a href="https://drive.google.com/file/d/1PGaPxNyESGmSOBJVYlnNu4iAfg1pW6IS/view"
          target="_blank">
        <button className="border border-gray-300 hover:border-[#00E6F6] hover:scale-110 transition-all duration-300 ease-in-out rounded-full px-3 py-2">Download CV</button></a>
      </div>
    </div>
  );
};

export default Home;
